import React from 'react'
import Image from 'next/image'
import styles from './MobileAppWidget.module.scss'

const MobileAppWidget = () => {
  return (
    <div className={styles.container}>
      <div>
        <div className={styles.text_section}>
          <h3>Level up your Sippy Life experience 📱</h3>
          <p>Our mobile app coming soon - be the first to know when we launch! 🎉"</p>
        </div>
        <div className={styles.links_container}>
            <div className={styles.icon}>
              <Image alt='' src='/svgs/coming_apple.svg' fill />
            </div>
           

            <div className={styles.icon}>
              <Image alt='' src='/svgs/coming_android.svg' fill />
            </div>
            
        </div>
      </div>
      <div className={styles.phone}>
        <Image alt='phoneImg' src='/svgs/mobileapp.svg' priority fill />
      </div>
      <div className={styles.image1}>
        <Image alt='star' src='/svgs/mobileAppStar.svg' fill />
      </div>
      <div className={styles.image2}>
        <Image alt='star' src='/svgs/star_blue.svg' fill />
      </div>
    </div>
  )
}

export default MobileAppWidget;